module.exports = __webpack_public_path__ + "static/media/BoxPlotMCQ2_2.f54b0f6c.svg";